import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../store';

import { IEventDetailedRound } from '../../store/admin/eventRounds/store';

export const useAdminRound = (roundId: number | string | undefined) => {
  const [round, setRound] = useState<IEventDetailedRound | undefined>();

  const { adminEventRounds } = useContext(GlobalContext);

  useEffect(() => {
    if (adminEventRounds && roundId) {
      setRound(adminEventRounds[Number(roundId)]);
    }
  }, [roundId, adminEventRounds]);

  return [round];
};
